import { call, select } from 'redux-saga/effects';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import cirrusClient from '../../../services/api/cirrus-client';

export function* startCallRecordingSaga(action) {
    try {
        const callId = action.payload;
        const { uid } = yield select(selectUserCredentials);
        // API endpoint for starting Call Recording
        const apiUrl = '?object=call&action=record_on';
        // Parameters for the API call
        const params = {
            format: 'json',
            callid: callId,
            uid: uid,
        };

        // Make the API call with the credentials
        const response = yield call(cirrusClient.get, apiUrl, { params });

    } catch (error) {
        console.error('Error starting Call Recording:', error);
    }
}